import Style from '@com/animation-editor/animationItem/index.less';
import Checkbox from '@tencent/dui/lib/components/Checkbox';
import React from 'react';

export enum MediaAnimPropertyType {
    'checkbox' = 'checkbox' // checkbox
}

interface MediaAnimItemProperty {
    // 属性名称
    title: string;
    // 属性类型，暂时有下拉选项和数字滑动条
    type: MediaAnimPropertyType,
    // 属性修改事件
    onPropertyChange: (value: string | number | boolean, changing?: boolean) => void
    // 属性值 value
    value: string | number | boolean;
}

const MediaAnimItemProperty = (props: MediaAnimItemProperty) => {
    const {
        title,
        type,
        onPropertyChange,
        value,
    } = props;

    let Component;

    if (type === MediaAnimPropertyType.checkbox) {
        Component = (
            <Checkbox
                onChange={checked => onPropertyChange(checked)}
                checked={!!value}
            >
                <span style={{ visibility: 'hidden' }}>1</span>
            </Checkbox>
        );
    }

    return (
        Component
            ? <div className={Style.item}>
                <span className={Style.itemTitle}>{title}</span>
                {Component}
            </div>
            : null
    );
};

export default MediaAnimItemProperty;
